import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import { PobbleAvatar } from 'pobble-components/dist/pobble-avatar'

import API from '../api'

import Close from 'react-icons/fa/times-circle'

@autobind
class StudentHeader extends Component {
  constructor (props) {
    super(props)
    this.state = {student: {}}
  }

  componentWillMount () {
    this.getStudent()
  }

  getStudent () {
    return API.get(`/v3/accounts/${this.props.studentId}?include=account.names,account.avatar`)
      .then(({data}) => {
        this.setState({student: data.account})
      })
  }

  render () {
    var studentName = this.state.student.display_name || this.state.student.first_name
    var student = <header className='StudentHeader'>
      <div className='StudentHeader__intro'>
        <PobbleAvatar avatar={this.state.student.avatar} name={studentName} style={{fontSize: '30px'}} className='StudentHeader__avatar' />
        <h1 className='StudentHeader__title'>{studentName}'s work</h1>
      </div>
      <div>
        <p className='StudentHeader__notice'>This page is only accessible by {studentName} and their parents.</p>
        <a className='StudentHeader__link StudentHeader__link--close' href='/'><span>Remove this filter </span><Close /></a>
      </div>
    </header>

    return (
      <div>{this.state.student && this.state.student.id && student}</div>
    )
  }
}

StudentHeader.propTypes = {
  studentId: PropTypes.string
}

export default StudentHeader



// WEBPACK FOOTER //
// ./components/search/StudentHeader.js